import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  overflow: hidden;
`;

export const BackgroundAnimation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  z-index: 0;
`;
export const OauthProviders = styled(motion.div)`
  display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    & .option{
      width:100%;
      & a{
        height: 41px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        background: #F8F8FB;
        border: 1px solid #DADAF2;
        border-radius: 5px;
        margin: 3px 0 5px;
        text-decoration: none;
        color: #171645;
        font-weight: 500;
        transition: .2s ease;
        cursor: pointer;
      }
    }
    & .divider{
      width: 100%;
      position: relative;
      height: 1px;
      background: #E6E6F2;
      margin: 10px 0;
      & .divider-text{
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translate(-50%);
        background: #fff;
        padding: 0 10px;
        color: #a6a6c1;
        &::before{
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 100%;
          height: 1px;
        }
        &::after{
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 100%;
          height: 1px;
        }
      }
    }
`;
export const FactoryFloorIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  transform: scale(1.2);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const GridOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 102, 255, 0.07) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 102, 255, 0.07) 1px, transparent 1px);
  background-size: 30px 30px;
  z-index: 1;
`;

export const HexagonPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5.5L7.5 18v24L30 54.5 52.5 42V18L30 5.5z' stroke='rgba(0, 102, 255, 0.1)' fill='none' stroke-width='1'/%3E%3C/svg%3E");
  background-position: 0 0, 10px 10px;
  opacity: 0.5;
  z-index: 1;
`;

export const LoginContainer = styled.div`
  display: flex;
  width: 900px;
  height: 580px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  position: relative;
  z-index: 10;
`;

export const GlowEffect = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 102, 255, 0.15) 0%, rgba(0, 102, 255, 0) 70%);
  filter: blur(20px);
  z-index: 0;
  animation: glow 8s infinite alternate;
  
  @keyframes glow {
    0% {
      opacity: 0.5;
      transform: scale(1);
    }
    100% {
      opacity: 0.8;
      transform: scale(1.3);
    }
  }
`;

export const BrandSection = styled.div`
  flex: 1;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  border-right: 1px solid rgba(0, 102, 255, 0.2);
`;

export const BrandTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 0.5rem;
  // font-family: 'Manrope', sans-serif;
  text-align: center;
  z-index: 3;
`;

export const BrandTagline = styled.p`
  font-size: 0.9rem;
  // font-family: 'Manrope', sans-serif;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  max-width: 280px;
  line-height: 1.6;
  z-index: 3;
  
`;

export const CircleDecoration = styled(motion.div)`
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.1);
  border: 1px solid rgba(0, 102, 255, 0.2);
  z-index: 1;
`;

export const LoginSection = styled.div`
  flex: 1;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #ffffff;
`;

export const ButterflyContainer = styled(motion.div)`
  position: relative;
  width: 180px;
  height: 180px;
  margin-bottom: 1.5rem;
  z-index: 3;
`;

export const ButterflyWing = styled(motion.div)`
  position: absolute;
  width: 70px;
  height: 90px;
  background: linear-gradient(135deg, rgba(0, 102, 255, 0.2) 0%, rgba(0, 145, 255, 0.4) 100%);
  border: 1px solid rgba(0, 102, 255, 0.5);
  border-radius: 80% 80% 40% 40%;
  box-shadow: 0 0 15px rgba(0, 102, 255, 0.3), inset 0 0 20px rgba(0, 102, 255, 0.2);
  backdrop-filter: blur(2px);
  transform-origin: bottom center;
`;

export const ButterflyLeftWing = styled(ButterflyWing)`
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%) scaleX(-1);
`;

export const ButterflyRightWing = styled(ButterflyWing)`
  top: 50%;
  left: 50%;
  transform: translate(0%, -50%);
`;

export const ButterflyBody = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 80px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 3px;
  z-index: 2;
`;

export const ButterflyPattern = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle, rgba(0, 102, 255, 0.8) 1px, transparent 1px),
    radial-gradient(circle, rgba(0, 102, 255, 0.4) 2px, transparent 2px);
  background-size: 20px 20px, 30px 30px;
  background-position: 0 0, 10px 10px;
  opacity: 0.5;
  z-index: 1;
`;

export const LoginTitle = styled.h2`
  font-size: 1.8rem;
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #000000;
  text-shadow: 0 0 10px rgba(0, 102, 255, 0.1);
`;

export const LoginSubtitle = styled.p`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 2rem;
`;

export const BiometricContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  padding-top:0px;
  position: relative;
`;

export const BiometricOptionsContainer = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  justify-content: center;
`;

export const BiometricOption = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;

export const MoreOptionsButton = styled(motion.button)`
  background: transparent;
  border: 1px solid rgba(0, 102, 255, 0.3);
  color: rgba(0, 0, 0, 0.7);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  cursor: pointer;
  
  &:hover {
    background: rgba(0, 102, 255, 0.05);
    color: #000000;
  }
`;

export const LoginFormContainer = styled(motion.div)`
  width: 400px;
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 102, 255, 0.1);
  position: relative;
  z-index: 10;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    z-index: -1;
  }
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 1.05rem;
  font-weight: 400;
  color: #000000;
`;

export const Input = styled.input`
  padding: 0.8rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.3);
  background: #ffffff;
  font-size: 1.1rem;
  
  &:focus {
    outline: none;
    border-color: rgba(0, 102, 255, 0.8);
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
`;

export const RememberMeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  accent-color: rgba(0, 102, 255, 0.8);
`;

export const RememberMeLabel = styled.label`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
`;

export const ForgotPassword = styled.a`
  font-size: 0.8rem;
  color: rgba(0, 102, 255, 0.8);
  text-align: right;
  margin-top: 0.5rem;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const LoginButton = styled(motion.button)`
  padding: 0.9rem;
  background: rgba(0, 102, 255, 0.8);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 102, 255, 1);
  }
`;

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
  
  &::before, &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(0, 102, 255, 0.3);
  }
  
  span {
    padding: 0 1rem;
    color: rgba(0, 0, 0, 0.7);
    font-size: 0.8rem;
  }
`;

export const SocialLoginContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

export const SocialLoginButton = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.3);
  background: #ffffff;
  cursor: pointer;
  
  &:hover {
    background: rgba(0, 102, 255, 0.05);
  }
`;

export const SignUpPrompt = styled.p`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  margin-top: 1.5rem;
  
  a {
    color: rgba(0, 102, 255, 0.8);
    font-weight: 500;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const BiometricButton = styled(motion.button)`
  padding: 0.9rem 1.5rem;
  background: rgba(0, 102, 255, 0.8);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 102, 255, 1);
  }
  
  &:disabled {
    background: rgba(0, 102, 255, 0.3);
    cursor: not-allowed;
  }
`;

export const BiometricIcon = styled.div`
  font-size: 2rem;
  color: rgba(0, 102, 255, 0.8);
  margin-bottom: 0.5rem;
  height: 70px;
  width: 70px;
`;

export const BiometricLabel = styled.div`
  font-size: 0.9rem;
  color: #000000;
  font-weight: 500;
`;

export const BiometricScanContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
`;

export const ScanningAnimation = styled(motion.div)`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 102, 255, 0.1) 0%, rgba(0, 102, 255, 0) 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid rgba(0, 102, 255, 0.2);
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(0.8);
      opacity: 1;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }
`;

export const ScanningStatus = styled.div`
  margin-top: 1.5rem;
  font-size: 1rem;
  color: #000000;
  font-weight: 500;
`;

export const ScanningProgress = styled.div`
  margin-top: 1rem;
  width: 200px;
  height: 4px;
  background: rgba(0, 102, 255, 0.1);
  border-radius: 2px;
  overflow: hidden;
  
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${props => props.progress || '0%'};
    background: rgba(0, 102, 255, 0.8);
    transition: width 0.3s ease;
  }
`;

export const AgentBotContainer = styled(motion.div)`
  position: relative;
  width: 200px;
  height: 200px;
  margin-bottom: 2rem;
`;

export const AgentBot = styled(motion.div)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 102, 255, 0.2) 0%, rgba(0, 102, 255, 0.1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    border: 2px solid rgba(0, 102, 255, 0.3);
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 60%;
    height: 60%;
    border-radius: 50%;
    border: 2px dashed rgba(0, 102, 255, 0.2);
    animation: rotate 10s linear infinite;
  }
  
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const AgentCore = styled.div`
  width: 40%;
  height: 40%;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.8);
  box-shadow: 0 0 20px rgba(0, 102, 255, 0.5);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  }
`;

export const AgentPulse = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid rgba(0, 102, 255, 0.5);
  opacity: 0;
`;

export const AgentName = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: #000000;
  margin-top: 1rem;
  text-align: center;
`;

export const AgentDescription = styled.div`
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  max-width: 300px;
  margin: 0.5rem auto 0;
`;

export const AgentStatusIndicator = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.status === 'active' ? 'rgba(0, 102, 255, 0.8)' : 'rgba(255, 0, 0, 0.8)'};
  bottom: 10px;
  right: 10px;
  box-shadow: 0 0 10px ${props => props.status === 'active' ? 'rgba(0, 102, 255, 0.8)' : 'rgba(255, 0, 0, 0.8)'};
`;

export const LoginOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`;

export const LoginOptionButton = styled(motion.button)`
  display: flex;
  align-items: center;
  padding: 1rem;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 102, 255, 0.05);
    border-color: rgba(0, 102, 255, 0.8);
  }
`;

export const LoginOptionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 102, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: rgba(0, 102, 255, 0.8);
  font-size: 1.2rem;
`;

export const LoginOptionText = styled.div`
  flex: 1;
  text-align: left;
`;

export const LoginOptionTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: #000000;
`;

export const LoginOptionDescription = styled.div`
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 0.2rem;
`;

export const MoreOptionsPanel = styled(motion.div)`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 10;
  margin-top: 1rem;
  border: 1px solid rgba(0, 102, 255, 0.2);
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 102, 255, 0.2);
`;

export const Tab = styled.button`
  padding: 0.5rem 1rem;
  background: ${props => props.active ? 'rgba(0, 102, 255, 0.1)' : 'transparent'};
  border: none;
  border-bottom: 2px solid ${props => props.active ? 'rgba(0, 102, 255, 0.8)' : 'transparent'};
  color: ${props => props.active ? '#000000' : 'rgba(0, 0, 0, 0.6)'};
  font-weight: ${props => props.active ? '500' : 'normal'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 102, 255, 0.05);
    color: #000000;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PinContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin: 1rem 0;
`;

export const PinInput = styled.input`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.3);
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  
  &:focus {
    outline: none;
    border-color: rgba(0, 102, 255, 0.8);
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
`;

export const BiometricCircle = styled(motion.div)`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid rgba(0, 102, 255, 0.3);
  }
`;

export const VideoFeed = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`;

export const StatusText = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  color: ${props => {
    if (props.status === 'success') return 'rgba(0, 180, 0, 0.8)';
    if (props.status === 'error') return 'rgba(255, 0, 0, 0.8)';
    return 'rgba(0, 102, 255, 0.8)';
  }};
  font-weight: 500;
  text-align: center;
`;

export const FaceGrid = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
`;

export const GridCell = styled.div`
  border: 1px dashed rgba(0, 102, 255, 0.3);
`;

export const VoiceVisualizer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 60px;
  width: 100%;
  gap: 2px;
  margin: 1rem 0;
`;

export const VoiceLine = styled.div`
  width: 4px;
  height: ${props => props.height || '10px'};
  background: rgba(0, 102, 255, 0.8);
  border-radius: 2px;
  transition: height 0.1s ease;
`;

export const AlternativeLogin = styled.div`
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.7);
  
  a {
    color: rgba(0, 102, 255, 0.8);
    font-weight: 500;
    text-decoration: none;
    margin-left: 0.3rem;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 2px;
  left: 0;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8rem;
  z-index: 10;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Copyright = styled.div`
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 0.3rem;
`;

export const TwoFactorModal = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;

export const TwoFactorCard = styled(motion.div)`
  background: white;
  border-radius: 10px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TwoFactorTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

export const TwoFactorDescription = styled.p`
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  color: #666;
  text-align: center;
`;

export const AgentBotHead = styled(motion.div)`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 50%;
  z-index: 2;
`;

export const AgentBotLeftEye = styled(motion.div)`
  position: absolute;
  top: 25%;
  left: 25%;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
`;

export const AgentBotRightEye = styled(motion.div)`
  position: absolute;
  top: 25%;
  right: 25%;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 50%;
`;

export const AgentBotMouth = styled(motion.div)`
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 4px;
  background: #ffffff;
  border-radius: 2px;
`;

export const AgentBotBody = styled(motion.div)`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 40px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 5px;
  z-index: 1;
`;

export const AgentBotLeftArm = styled(motion.div)`
  position: absolute;
  top: 45%;
  left: 35%;
  width: 8px;
  height: 25px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 4px;
  transform-origin: top center;
`;

export const AgentBotRightArm = styled(motion.div)`
  position: absolute;
  top: 45%;
  right: 35%;
  width: 8px;
  height: 25px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 4px;
  transform-origin: top center;
`;

export const AgentBotLeftLeg = styled(motion.div)`
  position: absolute;
  top: 70%;
  left: 40%;
  width: 8px;
  height: 25px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 4px;
  transform-origin: top center;
`;

export const AgentBotRightLeg = styled(motion.div)`
  position: absolute;
  top: 70%;
  right: 40%;
  width: 8px;
  height: 25px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 4px;
  transform-origin: top center;
`;

export const AgentBotLight = styled(motion.div)`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.8);
  box-shadow: 0 0 10px rgba(0, 102, 255, 0.5);
`;

export const AgentBotCircuit = styled(motion.div)`
  position: absolute;
  width: ${props => props.width || '20px'};
  height: ${props => props.height || '2px'};
  background: rgba(0, 102, 255, 0.3);
  border-radius: 1px;
`;

export const AgentBotPulse = styled(motion.div)`
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(0, 102, 255, 0.8);
  box-shadow: 0 0 8px rgba(0, 102, 255, 0.5);
`;

export const DigitalLogo = styled(motion.div)`
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: 1.5rem;
  position:relative;
  top:30px;
  left: -90px;
`;

export const LogoRing = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid rgba(0, 102, 255, 0.3);
  border-radius: 50%;
`;

export const LogoInnerCircle = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  border: 2px solid rgba(0, 102, 255, 0.5);
  border-radius: 50%;
`;

export const LogoDot = styled(motion.div)`
  position: absolute;
  width: 8px;
  height: 8px;
  background: rgba(0, 102, 255, 0.8);
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(0, 102, 255, 0.3);
`;

export const LogoLine = styled(motion.div)`
  position: absolute;
  background: rgba(0, 102, 255, 0.5);
  height: 2px;
  transform-origin: left center;
`;

export const DataStream = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const DataLine = styled(motion.div)`
  position: absolute;
  font-family: 'Courier New', monospace;
  font-size: 0.7rem;
  color: rgba(0, 102, 255, 0.5);
  white-space: nowrap;
  opacity: ${props => props.opacity || 0.5};
`;

export const Button = styled(motion.button)`
  padding: 0.9rem 1.5rem;
  background: rgba(0, 102, 255, 0.8);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  
  &:hover {
    background: rgba(0, 102, 255, 1);
  }
  
  &:disabled {
    background: rgba(0, 102, 255, 0.3);
    cursor: not-allowed;
  }
`;
